// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAeusde } from "../../../icons/full/build/icon-aeusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AeusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAeusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AeusdeIcon.displayName = 'AeusdeIcon';
}

export default AeusdeIcon;